import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

export default makeStyles((theme: Theme) => ({
  selectAll: {
    marginRight: 0,
    color: theme.palette.text.disabled,
  },
}));
